module.exports = __webpack_public_path__ + "img/Qatar.36059ce7.png";